
import axios from 'axios'
import { clientId, SCHOOL_Id } from "@/js/utils/constant";
import { logOut } from '@/js/utils/login.js'

const instance = axios.create({
});
const logoutCode = {
  "20200": "您的账号已在其他设备登录，为了您的账号安全，请重新登录",
  "20100": "会话已超时,请重新登录",
};
// instance.defaults.headers.common["content-type"] =
//   "application/x-www-form-urlencoded";
instance.defaults.withCredentials = true
instance.defaults.timeout = 30000
instance.defaults.headers.post['Content-Type'] = 'application/json';
//添加请求拦截器
instance.interceptors.request.use(function (config) {
    const token = localStorage.getItem("token");
    if (token) {
        config.headers["X-Client-Token"] = token;
    }
    config.headers["x-content-language"] = 'zh';
    config.headers["x-client-id"] = clientId;
    config.headers["x-device-id"] = localStorage.getItem("X-Device-Id");
    config.headers["x-version-num"] = 1;
    config.headers[SCHOOL_Id] = localStorage.getItem(SCHOOL_Id)||1;
    return config;
}, function (error) {
    console.error(error)
    return Promise.reject(error);
});
// 添加响应拦截器
instance.interceptors.response.use(function (response) {
    if (response.data.code == 20100) {
      logOut() // 退出登录
      return Promise.reject(response.data);
    } else {
      return Promise.resolve(response.data);
    }
}, function (error) {

    console.error(error)
    return Promise.reject(error);
})
// debugger
export default instance



// WEBPACK FOOTER //
// ./src/js/API/axios.js